import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router'
import { useSnackbar } from 'notistack';
import ImageGallery from 'react-image-gallery';
import InstalledEngine from './InstalledEngine'
import RemovedEngine from './RemovedEngine';
import { DropzoneArea } from 'material-ui-dropzone';
import { globalGetService, globalPostService, globalFileUploadService, globalDeleteService } from '../../../globalServices';
import { checkApiStatus } from '../../../utils_v2';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core';
import { DeletePopUp, PageLoader, STableLoader } from '../../../shared_elements';
import { trackActivity } from '../../../utils/mixpanel';
import { assetTypeId } from '../../../constants';

const PictureUpload = ({ toggleModalFn, onImportFile }) => {
    const [files, setFiles] = React.useState([]);
    const [previewFile, setPreviewFile] = useState({ modal: false, data: null, singlepreview: null })
    const handleFileUpload = () => {
        onImportFile(files)
    };
    const handleDropzoneChange = (uploadedFiles) => {
        setFiles(uploadedFiles);
    };
    return (
        <>
            <Dialog
                open={true}
                onClose={toggleModalFn}
            >
                <DialogTitle id="scroll-dialog-title">
                    Upload Pictures
                </DialogTitle>
                <DialogContent dividers={true}>
                    <div style={{ width: '380px' }}>
                        <DropzoneArea
                            filesLimit={5}
                            maxFileSize={104857600}
                            showPreviewsInDropzone={false}
                            useChipsForPreview={true}
                            acceptedFiles={['.png, .jpg, .jpeg, .heif, .heic']}
                            showPreviews={true}
                            dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                            dropzoneClass="drag-drop-cnt"
                            maxWidth="sm"
                            showAlerts={['info', 'error']}
                            alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                            clearOnUnmount={true}
                            onChange={handleDropzoneChange}
                            previewChipProps={{
                                onClick: (event) => {
                                    setPreviewFile({ modal: true, data: [files.find(item => item?.path === event?.target.textContent)], singlepreview: true })
                                }
                            }}
                        />
                    </div>
                    <span className='attachment-note'> Note : Max files upload limit is 5 in single time.</span>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleModalFn} color="primary" size='small' variant='outlined'>Cancel</Button>
                    <Button onClick={handleFileUpload} disabled={files?.length > 0 ? false : true} color="primary" size='small' variant='contained'>Proceed</Button>
                </DialogActions>

            </Dialog>
            {
                previewFile?.modal ?
                    <Dialog
                        open={previewFile?.modal}
                        onClose={() => setPreviewFile({ modal: false, data: null })}
                        style={{ height: "100vh" }}
                        fullWidth
                        maxWidth="lg"
                    >
                        <DialogTitle>
                            Image Preview
                        </DialogTitle>
                        <DialogContent dividers>
                            {previewFile?.singlepreview && previewFile?.data?.map((file, index) => (
                                <div key={index}>
                                    {
                                        file.type.startsWith('image/') && (
                                            <img src={URL.createObjectURL(file)} alt={file.name} style={{ width: '100%', height: '100vh' }} />
                                        )
                                    }
                                </div>
                            ))
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button color="primary" size='small' variant="outlined" onClick={() => setPreviewFile({ modal: false, data: null })}>Close</Button>
                        </DialogActions>
                    </Dialog> : null
            }
        </>
    )
}
const ImageSlider = ({ sliderInfo = {}, toggleModalFn }) => {
    return (
        <Dialog
            fullScreen
            open={sliderInfo?.modal}
            onClose={toggleModalFn}
        >
            <DialogTitle id="scroll-dialog-title">
                {sliderInfo?.title}
            </DialogTitle>
            <DialogContent dividers={true}>
                <ImageGallery
                    startIndex={sliderInfo?.startIndex}
                    items={sliderInfo?.images}
                    additionalClass="image-custom-preview"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={toggleModalFn} color="primary" size='small' variant='contained'>Cancel</Button>
            </DialogActions>
        </Dialog>
    )

}
function PhysicalReview({ params, currentFormDetail, getResponseBackForm }) {
    const [uploadPicture, setUploadPicture] = useState({ modal: false, data: null })
    const [sliderInfo, setSliderInfo] = useState({ modal: false, title: '', images: [], startIndex: null });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeltonLoader, setSkeltonLoader] = useState(true);
    const [data, setData] = useState({})
    const [initialValue, setInitialValue] = useState('');
    const [deletPicture, setDeletPicture] = useState({ modal: false, data: null })
    const [formSave, setFormSave] = useState({ open: false, type: '',isDisabled:false })

    useEffect(() => {
        const fetchData = async () => {
            setSkeltonLoader(true);
            trackActivity('Project Management', {
                event_type: 'Page Visited',
                page_title: 'T015 Form Physical Review'
            });
            const currentData = await getCurrentFormDetail('skeltonLoader');
            if (!currentData?.id) {
                try {
                    const postResponse = await globalPostService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/physical-review/2/`);
                    if (checkApiStatus(postResponse)) {
                        setData(postResponse?.data?.data);
                    } else {
                        enqueueSnackbar(postResponse?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                } catch (error) {
                    enqueueSnackbar('Failed to create data', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            }
            setSkeltonLoader(false);
        };
        fetchData();
    }, [params?.workOrderSlug, params?.formSlug]);

    const onFieldChange = (e, key, value, extraParam) => {
        if (key === 'last_removed_engine') {
            setData({ ...data, [key]: value });
            // callthisapi({ ...data, [key]: value })
        } else if (key === 'engine_stored' && (value === "YES")) {
            setData({ ...data, ['engine_is_stored']: "", [extraParam]: { ...data[extraParam], [key]: value } });
        } else if (extraParam === 'current_preservation' || extraParam === 'last_preservation') {
            setData({ ...data, [extraParam]: { ...data[extraParam], [key]: value } });
            // callthisapi({ ...data, [extraParam]: { ...data[extraParam], [key]: value } })
        } else {
            setData(prev => {
                if (extraParam) {
                    return { ...prev, [extraParam]: { ...prev[extraParam], [key]: value }, };
                }
                return { ...prev, [key]: value };
            })
        }
    };

    const getCurrentFormDetail = async (loaderType) => {
        if (loaderType === 'noloader') {
            setSkeltonLoader(false); setLoading(false)
        }
        else if (loaderType) {
            setSkeltonLoader(true)
        } else {
            setLoading(true)
        }
        try {
            const response = await globalGetService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/physical-review/${assetTypeId[params?.type]}/`);
            if (checkApiStatus(response)) {
                setData(response?.data?.data)
                return response?.data?.data;
            }
        } catch (error) {
            enqueueSnackbar('Failed to fetch data', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            return null;
        }
        finally {
            if (loaderType === 'noloader') { setSkeltonLoader(false); setLoading(false) } else if (loaderType) { setSkeltonLoader(false) } else { setLoading(false) }
            // if (loaderType) { setSkeltonLoader(false) } else { setLoading(false) }
        }
    };

    const callthisapi = (itemData, neValue) => {
        setLoading(true)
        let payload = Object.assign({}, itemData ? itemData : data)
        payload = {
            ...payload,
            position: payload?.position?.id || null
        }
        if (neValue !== initialValue) {
            globalPostService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/physical-review/${assetTypeId[params?.type]}/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setLoading(false)
                        getCurrentFormDetail();
                        getResponseBackForm()
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    } else {
                        setLoading(false)
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });

                    }
                });
        } else {
            setLoading(false)
        }
    }
    const onDeletePicture = () => {
        setLoading(true);
        globalDeleteService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/tct015physicalreview/${data?.id}/attachment/${assetTypeId[params?.type]}/${deletPicture?.data?.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeletPicture({ modal: false, data: null });
                    getCurrentFormDetail();
                    getResponseBackForm()
                    trackActivity('Project Management', {
                        event_type: 'Picture Upload',
                        page_title: 'T015 Form Physical Review',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        success_msg: 'T015 Physical Review Picture delete success'
                    })
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeletPicture({ modal: false, data: null });
                    getCurrentFormDetail();
                    trackActivity('Project Management', {
                        event_type: 'Picture Upload',
                        page_title: 'T015 Form Physical Review',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        error_msg: 'T015 Physical Review Picture delete failed'
                    })
                }
            })
    }
    const importFile = (files) => {
        let formData = new FormData();
        if (files?.length) {
            files.map(item => {
                formData.append('files', item)
            })
        }
        setLoading(true);
        globalFileUploadService(`technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/tct015physicalreview/${data?.id}/attachment/${assetTypeId[params?.type]}/?field=${uploadPicture?.data}`, formData)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false); setUploadPicture({ modal: false, data: null }); getCurrentFormDetail();
                    getResponseBackForm()
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Project Management', {
                        event_type: 'Picture Upload',
                        page_title: 'T015 Form Physical Review',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        success_msg: 'T015 Physical Review Picture uploaded success'
                    })
                } else {
                    setLoading(false);
                    getCurrentFormDetail();
                    trackActivity('Project Management', {
                        event_type: 'Picture Upload',
                        page_title: 'T015 Form Physical Review',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        error_msg: 'T015 Physical Review Picture uploaded failed'
                    })
                }
            })

    }
    return (
        <section className='physical-review-section form-t015' style={{ marginTop: '115px' }}>
            {skeltonLoader ? <STableLoader count={5} rowsFill={7} /> :
                data ? (<>
                    <InstalledEngine
                        data={data}
                        onFieldChange={onFieldChange}
                        isLoading={isLoading}
                        uploadPicture={uploadPicture}
                        sliderInfo={sliderInfo}
                        setSliderInfo={setSliderInfo}
                        setUploadPicture={setUploadPicture}
                        currentFormDetail={currentFormDetail}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        setDeletPicture={setDeletPicture}
                        setFormSave={setFormSave}
                        formSave={formSave}
                        getResponseBack={(loaderType) => getCurrentFormDetail(loaderType)}
                    />
                    <RemovedEngine
                        data={data}
                        onFieldChange={onFieldChange}
                        isLoading={isLoading}
                        uploadPicture={uploadPicture}
                        sliderInfo={sliderInfo}
                        setSliderInfo={setSliderInfo}
                        setUploadPicture={setUploadPicture}
                        currentFormDetail={currentFormDetail}
                        setInitialValue={setInitialValue}
                        setDeletPicture={setDeletPicture}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        setFormSave={setFormSave}
                        formSave={formSave}
                        getResponseBack={(loaderType) => getCurrentFormDetail(loaderType)}
                    /></>) : null}

            {uploadPicture?.modal ?
                <PictureUpload
                    onImportFile={(files) => importFile(files)}
                    uploadPictures={uploadPicture}
                    setLoading={setLoading}
                    getResponseBack={() => getCurrentFormDetail()}
                    toggleModalFn={() => setUploadPicture({ modal: false, data: null })} />
                : null
            }
            {sliderInfo?.modal ?
                <ImageSlider
                    sliderInfo={sliderInfo}
                    toggleModalFn={() => setSliderInfo({ modal: false, title: '', startIndex: null, images: [] })}
                /> : null
            }
            {
                deletPicture?.modal ?
                    <DeletePopUp
                        modal={deletPicture?.modal}
                        title='Delete Picture'
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDeletPicture({ modal: false, data: null })}
                        deleteRecordFn={onDeletePicture}
                    /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}

export default withRouter(PhysicalReview)